import Vue from 'vue'
import Vuex from 'vuex'
import staticData from '@api/staticData'

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const store = new Vuex.Store({
    plugins: [
        createPersistedState({
            // Não persiste dados do PDI para evitar problemas de cache
            filter: (mutation) => {
                const pdiMutations = ['clearPdiCache', 'setPdiResponsesSaved'];
                return !pdiMutations.includes(mutation.type);
            },
            // Não persiste propriedades específicas do PDI
            reducer: (state) => {
                const { pdiDueData, pdiResponsesSaved, pdiCompletedToday, pdiLastCheck, ...persistedState } = state;
                return persistedState;
            }
        })
    ],
    state: {
        modalNaoPermitido: false,
        logo: null,
        cor: '#F1892C',
        isLogged: false,
        pdiPendente: [],
        loading: false,
        user: null,
        unreadChats: [],
        listaEstados: [],
        listaBanco: [],
        pdiDueData: null,
        pdiResponsesSaved: false,
        pdiCompletedToday: false,
        pdiLastCheck: null,
        filtroSuporte: {
            itemsPerPage: 25,
            search: '',
            selectedDate: [],
            statusList: [1],
            usuario_id: ''
        },
        filtroHome: {
            usuario_id: '',
            pendentes: true,
            concluidos: false,
            atrasados: false,
            cliente_id: '',
            selectedDate: [
                new Date(new Date().setDate(new Date().getDate() - 30)),
                new Date(),
            ],
        },
        filtroTarefa: {
            itemsPerPage: 25,
            search: '',
        },
        filtroRps: {
            itemsPerPage: 25,
            search: '',
        },
        filtroContaReceber: {
            itemsPerPage: 25,
            search: '',
        },
        filtroContaPagar: {
            itemsPerPage: 25,
            search: '',
        },
        filtroLancamento: {
            itemsPerPage: 25,
            search: '',
        },
        filtroOportunidade: {
            itemsPerPage: 25,
            search: '',
            inativos: true,
        },
        tituloImpressao: '',
        headersImpressao: [],
        conteudoImpressao: [],
        isFromImpressao: '',
        totalImpressao: '',
    },
    getters: {

    },
    mutations : {
        isLogged(state, payload){
            state.isLogged = payload
        },
        setPdiPendente(state, payload){
            state.pdiPendente = payload
        },
        setLoading(state, payload){
            state.loading = payload
        },
        setUser(state, payload){
            state.user = payload
        },
        setUnreadChats(state, payload){
            state.unreadChats = payload
        },
        setListaEstados(state, payload){
            state.listaEstados = payload
        },

        setFiltroHome(state, payload){
            state.filtroHome = payload
        },

        setFiltroTarefa(state, payload){
            state.filtroTarefa = payload
        },

        setFiltroRps(state, payload){
            state.filtroRps = payload
        },

        setFiltroContaReceber(state, payload){
            state.filtroContaReceber = payload
        },

        setFiltroContaPagar(state, payload){
            state.filtroContaPagar = payload
        },

        setFiltroLancamento(state, payload){
            state.filtroLancamento = payload
        },

        setFiltroOportunidade(state, payload){
            state.filtroOportunidade = payload
        },

        setFiltroSuporte(state, payload){
            state.filtroSuporte = payload
        },

        setHeadersImpressao(state, payload){
            state.headersImpressao = payload
        },

        setConteudoImpressao(state, payload){
            state.conteudoImpressao = payload
        },

        setTotalImpressao(state, payload){
            state.totalImpressao = payload
        },

        setTituloImpressao(state, payload){
            state.tituloImpressao = payload
        },

        setIsFromImpressao(state, payload){
            state.isFromImpressao = payload
        },
        setLogo(state, payload){
            state.logo = payload
        },
        setCor(state, payload){
            state.cor = payload
        },
        setListaBanco(state, payload) {
            state.listaBanco = payload
        },

        // Mutations para PDI
        clearPdiCache(state) {
            state.pdiDueData = null;
            state.pdiResponsesSaved = false;
            state.pdiCompletedToday = false;
            state.pdiLastCheck = null;
        },

        setPdiResponsesSaved(state, payload) {
            state.pdiResponsesSaved = payload;
        },

    },
    actions: {
        async loadStaticData({commit}){

            const listaStaticData = await staticData.getAll()
            commit('setListaEstados', listaStaticData.data.estados)
            commit('setLogo', listaStaticData.data.empresa.imagem)
            commit('setCor', listaStaticData.data.empresa.cor)
            commit('setListaBanco', listaStaticData.data.banco)

        },

        // Action para limpar cache do PDI
        clearPdiCache({commit}) {
            commit('clearPdiCache')
        },

        // Action para inicializar o store (sempre limpa cache do PDI)
        initializeStore({commit}) {
            commit('clearPdiCache'); // Sempre limpa o cache do PDI ao inicializar
        }
    },
})

export default store
